module.exports = __webpack_public_path__ + "static/CSS-logo-b848d5d9bb221592064de0f356f61676.png";